<template>
  <v-container
    class="pt-4"
    fluid
  >
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="currentSociety"
          :items="socData"
          item-text="name"
          item-value="id_soc"
          :label="$t('akito.account-name')"
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        :cols="currentPlayer === undefined ? '12' : '6'"
        class="list-overflow"
      >
        <v-list>
          <v-list-item-group v-model="currentPlayer">
            <v-list-item
              v-for="player in playerData"
              :key="player.key"
            >
              <v-list-item-title>{{ player.name }}</v-list-item-title>
              <v-list-item-action>
                <v-icon>mdi-pencil</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col
        v-if="currentPlayer !== undefined"
        cols="6"
      >
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="playerData[currentPlayer].name"
                :label="$t('profile.sections.common.name')"
                readonly
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="playerData[currentPlayer].identifier"
                :label="$t('profile.sections.player.license')"
                readonly
                dense
              />
            </v-col>
          </v-row>
          <v-col>
            <v-text-field
              v-model="search"
              :label="$t('akito.account-search')"
              single-line
              hide-details
              append-icon="mdi-magnify"
              clearable
              dense
            />
            <v-treeview
              v-model="associatedSocieties"
              :items="socData"
              :search="search"
              item-key="id_soc"
              selectable
            />
          </v-col>
          <v-row>
            <v-col cols="6">
              <v-btn
                color="success"
                :disabled="associatedSocieties.length == 0"
                @click="linkPlayerToSociety(playerData[currentPlayer].plyr_id)"
              >
                <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.update") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components

// Connectors

import { ProfileSocietyConnector } from "../../Database/ProfileSocietyConnector.js";

export default {
  components: {},
  data() {
    return {
      societyConnector: new ProfileSocietyConnector(this.$store.state.user),
      playerData: [],
      currentSociety: 0,
      socData: [],
      currentPlayer: undefined,
      search: "",
      associatedSocieties: [],
    };
  },
  watch: {
    currentSociety: function (val) {
      this.currentPlayer = undefined;
      this.getPlayerForSoc(val);
    },

    currentPlayer: function () {
      if (this.currentPlayer !== undefined) {
        this.getAssociatedSoc();
      }
    },
  },
  created() {
    this.getSociety();
  },
  methods: {
    getSociety() {
      this.societyConnector.getSoc().then((response) => {
        this.socData = response;
      });
    },
    getPlayerForSoc(val) {
      this.societyConnector.getPlayerForSoc(val).then((players) => {
        // TODO: format in db server
        this.playerData = players.map((data) => {
          return {
            plyr_id: data.plyr_id,
            name: data.name,
            identifier: data.identifier,
          };
        });
      });
    },

    getAssociatedSoc() {
      const pid = parseInt(this.playerData[this.currentPlayer].plyr_id);
      if (pid !== undefined) {
        this.societyConnector.getAssociatedSoc(pid).then((response) => {
          this.associatedSocieties = response;
        });
      }
    },

    linkPlayerToSociety(playerId) {
      this.societyConnector
        .updateAssociatedSoc(playerId, this.associatedSocieties)
        .then(() => {
          // this.dialogOpen = true;
          // this.dialogHeader = this.$t("dialog.info");
          // this.dialogContent = this.$t("dialog.update-associate");
          // this.dialogType = "info";
          this.$store.dispatch("openSnackbar", {
            txt: this.$t("dialog.update-associate"),
            colorBg: "green",
          });
        })
        .catch((err) => {
          // this.dialogOpen = true;
          // this.dialogHeader = this.$t("dialog.warning");
          // this.dialogContent = this.$t("error.update");
          // this.dialogType = "warning";
          this.$store.dispatch("openSnackbar", {
            title: this.$t("dialog.warning"),
            txt: this.$t("error.update"),
            colorBg: "red",
          });
          console.error(err);
        });
    },
  },
};
</script>

<style></style>
